<template>
  <v-app>
    <v-navigation-drawer app v-model="drawer" clipped>
      <v-container>
        <!-- <v-list-item>
          <v-list-item-content>
            <v-list-item-title class="title grey--text text--darken-2">
              ナビゲーションリスト
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider> -->
        <v-list nav dense>
          <v-list-group 
            v-for="nav_list in nav_lists" 
            :key="nav_list.name" 
            :prepend-icon="nav_list.icon" 
            :to="nav_list.link"
            no-action 
            :append-icon="nav_list.lists ? undefined : ''"> 
            <template v-slot:activator>
              <v-list-item-content>
                <router-link :to="nav_list.link" style="text-decoration:none;"><v-list-item-title :to="nav_list.link">{{ nav_list.name }}</v-list-item-title></router-link>
              </v-list-item-content>
            </template>
            <v-list-item v-for="list in nav_list.lists" :key="list">
              <v-list-item-content>
                <v-list-item-title>{{ list }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
        </v-list>
      </v-container>
    </v-navigation-drawer>
    <v-app-bar color="white" app clipped-left style="box-shadow:none;">
      <v-app-bar-nav-icon  @click="drawer=!drawer"></v-app-bar-nav-icon>
      <v-toolbar-title>Motoike's Portfolio Website</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-btn text @click="getUrl">
          <v-icon>mdi-twitter</v-icon>
        </v-btn>
        <v-btn text>
          <v-icon>mdi-facebook</v-icon>
        </v-btn>
        <v-btn text>お問い合わせ</v-btn>
        <v-menu offset-y>
          <template v-slot:activator="{on}">
          <v-btn v-on="on" text>日本語<v-icon>mdi-menu-down</v-icon></v-btn>
          </template>
          <v-list>
            <!-- <v-subheader>Get help</v-subheader> -->
            <v-list-item v-for="lang in langs" :key="lang">
              <v-list-item-content>
                <v-list-item-title>{{ lang }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-toolbar-items>
    </v-app-bar>

    <v-main>
      <router-view />
    </v-main>

    <v-footer align="center" color="white" style="justify-content: center;" mx-auto app>
      ©2020-2020 Motoike's Portfolio Website All right resereved.
    </v-footer>
  </v-app>
</template>

<script>
// import HelloWorld from './components/HelloWorld';

export default {
  name: 'App',

  components: {
    // HelloWorld,
  },

  data () {
    return{
        drawer: null,
        langs:[
          '日本語',
          'English',
          '簡体中文'
        ],
        nav_lists:[
          // {
          // name: 'Getting Started',
          // icon: 'mdi-speedometer',
          // lists:['Quick Start','Pre-made layouts']
          // },
          {
          name: 'トップページ',
          icon: 'mdi-arrow-up-bold-circle-outline',
          link:'/' 
          },
          // {
          // name: 'Styles & animations',
          // icon: 'mdi-palette',
          // lists:['Colors','Content','Display']
          // },
          // {
          // name: 'UI Components',
          // icon: 'mdi-view-dashboard',
          // lists:['API explorer','Alerts']
          // },
          {
          name: 'ポートフォリオ',
          icon: 'mdi-alpha-p-box-outline',
          link:'/#portfolio'
          },
          {
          name: 'プロフィール',
          icon: 'mdi-face-profile',
          link:'/profile'
          },
        ]
    }
  },
  methods: {
    getUrl() {
      window.open('https://twitter.com/moto_shin_', '_blank');
    }
  }
};
</script>

<style scoped>
body {
  font-family: 'Unna', serif;
}
</style>
